import React, { StrictMode, Fragment, useState, useRef, useMemo, useEffect } from 'react'
import { isNil, sortBy, isEmpty, some } from 'lodash'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { Alert, Col, Row } from 'camino-react'

import { cloudhelpGet } from 'Utilities/CloudHelp'
import { 
  setOptions, 
  fetchContractsAndServices, 
  getServiceCategoryOptions, 
  getServiceSubCategoryOptions 
} from './CategoryOptions'

function ContractAndServices({
  service_category_id, 
  sub_category_id, 
  handleSelectChange, 
  setFieldErrorClasses, 
  clientId,
  isLoading, 
  setIsLoading,
  customer_contract_id,
  setAlert,
  setServiceCategories,
  ticket_type_id,
  service_id,
  service_type,
  currentUser,
}) {
  const isFirstRender = useRef(true);
  const [contractOptions, setContractOptions] = useState([])
  const [serviceOptions, setServiceOptions] = useState([])
  const setContractSelectOptions = (options) => (
    setOptions({ options, setContractOptions, customer_contract_id, service_id, setServiceOptions, setServiceCategories }) 
  )

  useEffect(() => {
    if (!isNil(clientId)) {
      const request = fetchContractsAndServices({ clientId, setContractSelectOptions, setAlert, setIsLoading });

      return request
    }
  }, [clientId]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      setContractSelectOptions(contractOptions)
      handleSelectChange('service_category_id', { value: null });
      handleSelectChange('sub_category_id', { value: null });
    }
  }, [customer_contract_id, service_id, ticket_type_id]); 

  return (
    <Row>
      <Col width={12}>
        <label>Contract</label>
        <Select
          className={setFieldErrorClasses('customer_contract_id')}
          value={customer_contract_id}
          onChange={option => handleSelectChange('customer_contract_id', option)}
          options={sortBy(contractOptions, 'label')}
          placeholder='-'
          isLoading={isLoading}
          clearable={false}
        />
      </Col>

      <Col width={12}>
        <label>Service</label>
        <Select
          className={setFieldErrorClasses('service_id')}
          value={service_id}
          onChange={option => {
            handleSelectChange('service_id', option)
            handleSelectChange('service_type', { value: option.type })
          }}
          options={serviceOptions}
          placeholder='-'
          isLoading={isLoading}
          clearable={false}
        />
      </Col>
    </Row>
  )
}

function ServiceCategories({ 
  service_category_id, 
  sub_category_id, 
  handleSelectChange, 
  setFieldErrorClasses, 
  clientId,
  customer_contract_id,
  ticket_type_id,
  service_id,
  service_type,
  currentUser,
  guestServiceCategories
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [serviceCategories, setServiceCategories] = useState(currentUser.guest_user ? guestServiceCategories : [])
  const [alert, setAlert] = useState({ title: '', show: false })
  const serviceCategoryOptions = getServiceCategoryOptions(serviceCategories, ticket_type_id, currentUser.guest_user)
  const serviceSubCategoryOptions = getServiceSubCategoryOptions(serviceCategories, service_category_id, ticket_type_id, currentUser.guest_user)

  return (
    <StrictMode>
      <Fragment>
        {alert.show && <Alert {...alert} />}

        {!currentUser.guest_user && (
          <ContractAndServices {...{
            service_category_id, 
            sub_category_id, 
            handleSelectChange, 
            setFieldErrorClasses, 
            setAlert,
            setServiceCategories,
            isLoading, 
            setIsLoading,
            clientId,
            customer_contract_id,
            ticket_type_id,
            service_id,
            service_type,
            currentUser,
          }} />
        )}

        <Row>
          <Col width={12}>
            <label>Service Category</label>
            <Select
              className={setFieldErrorClasses('service_category_id')}
              value={service_category_id}
              onChange={option => handleSelectChange('service_category_id', option)}
              options={sortBy(serviceCategoryOptions, 'label')}
              isLoading={isLoading}
              placeholder='-'
              clearable={false}
            />
          </Col>

          <Col width={12}>
            <label>Sub Category</label>
            <Select
              className={setFieldErrorClasses('sub_category_id')}
              value={sub_category_id}
              onChange={option => handleSelectChange('sub_category_id', option)}
              options={serviceSubCategoryOptions}
              placeholder='-'
              isLoading={isLoading}
              clearable={false}
            />
          </Col>
        </Row>
      </Fragment>
    </StrictMode>
  )
}

export default ServiceCategories
